"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var R_SEP = /<(\/|#)?(\d+)(\/?)>/g;
var R_CLEANER = /(?:,)(\n\s*\))/g;
var EMPTY_STRING = '';
var HASH_BANG = '#';
var INDENT = '  ';
var INDENT_INC = 'inc';
var INDENT_DEC = 'dec';
function createCompiler(spec) {
    var COMPILED = {};
    return function compile(phrase) {
        if (COMPILED.hasOwnProperty(phrase)) {
            return COMPILED[phrase];
        }
        var source = [];
        var tokens = phrase.split(R_SEP);
        var indent = EMPTY_STRING;
        var compiled = null;
        function write(code, ind) {
            if (ind === INDENT_DEC) {
                indent = indent.slice(2);
            }
            source.push("" + indent + code);
            if (ind === INDENT_INC) {
                indent += INDENT;
            }
        }
        write(EMPTY_STRING);
        write(spec.before(), INDENT_INC);
        for (var i = 0; i < tokens.length; i += 4) {
            var text = tokens[i];
            var type = tokens[i + 1];
            var partIdx = +tokens[i + 2] + spec.partOffset;
            var selfClosed = tokens[i + 3];
            if (text !== EMPTY_STRING) {
                write(spec.text(JSON.stringify(text)));
            }
            if (type === HASH_BANG) {
                write(spec.value("__parts__[" + partIdx + "]", partIdx));
            }
            else if (selfClosed) {
                write(spec.selfClose("__parts__[" + partIdx + "]", partIdx));
            }
            else if (type === '/') {
                write(spec.close("__parts__[" + partIdx + "]", partIdx), INDENT_DEC);
            }
            else if (partIdx) {
                write(spec.open("__parts__[" + partIdx + "]", partIdx), INDENT_INC);
            }
        }
        write(spec.after(), INDENT_DEC);
        var code = (spec.inject ? "var " + Object
            .keys(spec.inject)
            .map(function (name) { return name + " = __INJECT__['" + name + "']"; })
            .join(';\nvar ') + ";" : "") + "\n\t\treturn function (__parts__) {return (" + source.join('\n').replace(R_CLEANER, '$1') + ")}";
        try {
            compiled = Function("__INJECT__", code)(spec.inject);
        }
        catch (err) {
            compiled = function () { return phrase + "\n---------\n" + err.message + "\n---------\n" + code; };
        }
        COMPILED[phrase] = compiled;
        return compiled;
    };
}
exports.createCompiler = createCompiler;
